<template>
  <div>
    <!-- Encabezado -->
    <b-container fluid class="text-center py-4 border rounded bg-primary text-white">
      <h1 class="text-white">Bienvenido a la Universidad Mariano Gálvez 🎓</h1>
      <p class="mb-0">Sistema de Asignación de Cursos - Gestión Académica Integral</p>
    </b-container>

    <!-- Carrusel -->
    <b-container class="my-4">
      <b-carousel
        id="carousel-umg"
        controls
        indicators
        background="#21739B"
        :interval="4000"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #000"
        fade
      >
        <b-carousel-slide
          v-for="(img, index) in imagenes"
          :key="index"
          :img-src="img.url"
        >
          <h3 class="text-white">{{ img.titulo }}</h3>
          <p>{{ img.descripcion }}</p>
        </b-carousel-slide>
      </b-carousel>
    </b-container>

    <!-- Información adicional -->
    <b-container class="my-5">
      <b-row>
        <b-col md="4" class="text-center mb-4">
          <div class="p-4 border rounded">
            <h4 class="text-primary">📚 Gestión de Cursos</h4>
            <p>Administra y asigna cursos de manera eficiente</p>
          </div>
        </b-col>
        <b-col md="4" class="text-center mb-4">
          <div class="p-4 border rounded">
            <h4 class="text-primary">👨‍🏫 Profesores</h4>
            <p>Gestiona la información y carga académica de los docentes</p>
          </div>
        </b-col>
        <b-col md="4" class="text-center mb-4">
          <div class="p-4 border rounded">
            <h4 class="text-primary">🏫 Aulas</h4>
            <p>Controla la disponibilidad y asignación de espacios</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      imagenes: [
        {
          url: require('@/assets/images/umg/Facultad_que_apasiona-xl.webp'),
          titulo: 'Facultad que Apasiona',
          descripcion: 'Formamos profesionales comprometidos con la excelencia académica y el desarrollo del país.'
        },
        {
          url: require('@/assets/images/umg/Campus_Central_vista_dron-xl.webp'),
          titulo: 'Campus Central',
          descripcion: 'Nuestro moderno campus ofrece las mejores instalaciones para tu formación profesional.'
        },
        {
          url: require('@/assets/images/umg/banner-xl1.webp'),
          titulo: 'Educación de Calidad',
          descripcion: 'Más de 50 años formando profesionales exitosos en Guatemala y el mundo.'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* Estilo responsivo adicional */
@media (max-width: 768px) {
  h3 {
    font-size: 1.3rem;
  }

  p {
    font-size: 0.95rem;
  }
}
</style>
